<template>
	<div class="add_hooky">
		<ul class="add_hooky__accordion" uk-accordion>
			<li class="">
				<a class="uk-accordion-title" href="#">Заявить о пропуске занятия</a>
				<div class="uk-accordion-content">
					<p>Вы можете пропустить только 3 занятия в квартал.</p>
					<label>
						<span class="l_title">Выберите дату</span>
						<input id="r_dates" type="text" class="uk-input stats__inp" placeholder="Дата" autocomplete="off" />
					</label>
					<div class="add_hooky__button">
						<button class="uk-button uk-button-primary" @click="onSendHooky">Отправить заявление</button>
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	import axios from 'axios'
  export default {
    name: "add_hooky",
    data() {
      return {
        date: ''
      }
    },
    props: {
      items: ''
    },
	  computed: {
      user(){
        return this.$store.state.user;
      }
	  },
    methods: {
      /** Инициализируем датепикер */
      initDatepicker() {
        let app = this;
        let datepicker = $('#r_dates').datepicker({
          multipleDates: false,
          dateFormat: "dd-mm-yyyy",
          //minDate: new Date(),
          onSelect(formattedDate, date, inst) {
            app.date = formattedDate;
          }
        })
      },
      onSendHooky() {
        if (this.date) {
          let data = {
            'date': this.date,
	          'user_id': this.user.id
          }
          //console.log(data);
	        let app = this;
          this.$root.wait = true;
          axios.post(window.location.href, data, {
            headers: {
              'X-OCTOBER-REQUEST-HANDLER': 'onSendHooky',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(function (res) {
            console.log(res.data);
            UIkit.accordion('.add_hooky__accordion').toggle(0);
            app.$root.wait = false;
            if(res.data.message){
              swal(res.data.message, '', 'success');
            }
          });
        } else {
          swal(
            'Выберите дату!', '', 'warning',
          );
        }
      }
    },
    mounted() {
      this.initDatepicker();
    }
  }
</script>